<template>
    <div id="ag-grid-demo">

            <vx-card>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Merchant</span>
                    </div>
                    <div class="vx-col sm:w-4/5 w-full">
                      <vue-simple-suggest
                        pattern="\w+"
                        v-model="model"
                        :list="getList"
                        :max-suggestions="1000"
                        :min-length="0"
                        :debounce="200"
                        :filter-by-query="false"
                        :prevent-submit="true"
                        :controls="{
                          selectionUp: [38, 33],
                          selectionDown: [40, 34],
                          select: [13, 36],
                          hideList: [27, 35]
                        }"
                        :mode="mode"
                        :nullable-select="true"
                        ref="suggestComponent"
                        placeholder="Search information..."
                        value-attribute="id"
                        display-attribute="text"
                        @select="onSuggestSelect"
                      >
                        <div class="g">
                          <input id="merchant-search" type="text" placeholder="Select merchant">
                        </div>

                        <template slot="misc-item-above" slot-scope="{ suggestions, query }">
                          <div class="misc-item">
                            <span>You're searching for '{{ query }}'.</span>
                          </div>

                          <template v-if="suggestions.length > 0">
                            <div class="misc-item">
                              <span>{{ suggestions.length }} suggestions are shown...</span>
                            </div>
                            <hr>
                          </template>

                          <div class="misc-item" v-else-if="!loading">
                            <span>No results</span>
                          </div>
                        </template>

                        <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
                          <div class="text">
                            <span v-html="boldenSuggestion(scope)"></span>
                          </div>
                        </div>

                        <div class="misc-item" slot="misc-item-below" slot-scope="{}"
                              v-if="loading">
                          <span>Loading...</span>
                        </div>
                      </vue-simple-suggest>
                    </div>
                </div>

                  <!-- Filter date
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>Date</span>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                      <flat-pickr id="dtp-transaction-summary-datebegin" :config="configFromdatePicker" v-model="filter.date_begin" placeholder="Date begin" @on-change="onFromChange"/>
                    </div>
                    <div class="vx-col sm:w-2/5 w-full">
                      <flat-pickr id="dtp-transaction-summary-dateend" :config="configTodatePicker" v-model="filter.date_end" placeholder="Date end" @on-change="onToChange"/>
                    </div>
                </div>
                 -->

  

                <!-- Button -->
                <div class="vx-row">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>&nbsp;</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-button id="btn-filter" icon-pack="feather" icon="icon-search" v-on:click="fetchData(1,20)" class="mr-3 mb-2 float-left">Filter</vs-button>
                        <vs-button id="btn-reset" icon-pack="feather" icon="icon-refresh-cw" color="warning" v-on:click="resetSearch()" class="mr-3 mb-2 float-left">Reset</vs-button>
                    </div>
                </div>
            </vx-card>

            <!-- Show total online - offline -->
             <vx-card>
            <div class="vx-row h-100">
            <div class="vx-col md:w-4/4 w-full mb-base" v-if="displayNote">
              <vs-alert active="true" icon="info" >
                Notes: Device akan dinyatakan offline setelah pengiriman last hearbeat > {{lastMaxHeartBeatTime}}
              </vs-alert>
              <vs-alert active="true" icon="info" >
                Notes: Data yang ditampilkan adalah data pada hari yang sedang berjalan
              </vs-alert>
            </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
              <a @click="offlineFilter()" style="cursor:pointer" >
                <vx-card style="background:rgb(242, 19, 93); color:white">
                  <div class="flex justify-between flex-row-reverse items-center">
                    <span class="p-1 inline-flex rounded-full feather-icon select-none relative text-danger" style="background: rgba(var(--vs-danger),0.15);">
                      <vs-avatar color="danger" icon="close" />
                    </span> 
                    <div class="truncate">
                      <h3 class="mb-1 font-bold" style="color:white">Device Offline: <span style="letter-spacing: 5px;"> {{totalOffline}}/{{totalData}}</span></h3> 
                      <span>{{totalOfflinePercentage}}% Device is Offline </span>
                    </div>
                  </div>
                </vx-card>
                </a>
              </div>
             
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
                <a @click="onlineFilter()" style="cursor:pointer" >
                  <vx-card style="background:rgb(23, 201, 100); color:white">
                    <div class="flex justify-between flex-row-reverse items-center">
                      <span class="p-1 inline-flex rounded-full feather-icon select-none relative text-success" style="background: rgba(var(--vs-success),0.15);">
                        <vs-avatar color="success" icon="verified_user" />
                      </span> 
                      <div class="truncate">
                        <h2 class="mb-1 font-bold" style="color:white">Device Online:  <span style="letter-spacing: 5px;">{{totalOnline}}/{{totalData}}</span></h2> 
                        <span>{{totalOnlinePercentage}}% Device is Online </span>
                      </div>
                    </div>
                  </vx-card>
                </a>
              </div>
            </div>

            </vx-card>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import {url} from "@/configs/apiUrl";
    import Axios from "@/global/AxiosCall";
    import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
    import vSelect from 'vue-select'
    import VueSimpleSuggest from 'vue-simple-suggest';
    import 'vue-simple-suggest/dist/styles.css'
    import XLSX from "xlsx"
    import moment from 'moment'

    export default {
        name: "DeviceMonitoring",
        components: {
            AgGridVue,
            VueSimpleSuggest,
            'v-select': vSelect,
        },
        data(){
            return {
                filterStatus: '',
                statusList: [
                  {id: 0, label: "ALL"},
                  {id: 1, label: "ONLINE"},
                  {id: 2, label: "OFFLINE"},
                ],
                displayNote: false,
                lastMaxHeartBeatTime: '',
                chosen: '',
                selected: null,
                model: null,
                mode: 'input',
                loading: false,
                log: [],
                urlx: null,
                interval: null,
                sortListColumn: '',
                sortListType: '',
                floatingFiltersHeight: 0,
                currentPageTable: 1,
                currentPage: 1,
                isMerchantUser : false,
                filterDevice: 'All Device',
                searchQuery: "",
                gridOptions: {},
                maxPageNumbers: 10,
                gridApi: null,
                defaultColDef: {
                    sortable: false,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },

                dataTrx: [],
                dataCount: 0,
                totalData: 0,
                totalOnline: 0,
                totalOnlinePercentage: 0,
                totalOffline: 0,
                totalOfflinePercentage: 0,
                merchant_list: [],
                device_list: [],
                filter_merchant: '',
                filter_device: '',
            };
        },
        watch: {
            selected: function(val) {
              let merchantidquery = ""
              this.filter_device = ''
              if (val !== null) {
                if (typeof val.merchant_id!=="undefined") {
                  merchantidquery = "?merchant_id="+val.merchant_id
                }
              }

              Axios.Get(url.svd.device.combo+merchantidquery).then(resp => {
                  this.device_list = []
                  if (typeof resp.data !== 'undefined')
                      for(let data of resp.data) {
                          data.label = data.name+' - '+data.code+' - '+data.merchant_full_name
                          this.device_list.push(data)
                      }
              })
            },
        },
        methods: {
            offlineFilter() {
              let data = {
                status: "offline",
                limit:  this.totalOffline,
                page: 1,
              }
              this.$router.push({name:'DeviceMonitoring' ,params: {data:data}})
            },
            onlineFilter() {
              let data = {
                status: "online",
                limit:  this.totalOnline,
                page: 1,
              }
              this.$router.push({name:'DeviceMonitoring' ,params: {data:data}})
            },

            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val);
            },
            resetSearch(){
              document.getElementById("merchant-search").value = ""
              this.model = null
              this.selected = null
              this.filter_device = ""
              this.fetchData(1, 20)
              this.displayNote = false
              this.maxLastHeartBeatTime = ''
            },
            fetchData(page, limit) {
                this.openLoading()

                let newUrl = ""

                newUrl = url.device_monitoring.list+ "?page=" + page + "&limit=" + limit

                let device_code = ""

                if (this.selected !== "" && this.selected !== null && (this.filter_device === "" || this.filter_device === null)) {
                   for (let data of this.device_list){
                      if (data.code !== "") device_code += data.code+","
                  }
                  device_code = device_code.replace(/,\s*$/, "")
                  if(this.selected.code != "select_all" && this.selected.depth !== "1") {
                    newUrl +=  "&devicecode="+ device_code
                  }
                }


                if(this.filter_device !== "" && this.filter_device !== null){
                  newUrl +=  "&devicecode="+ this.filter_device.code
                }

                if (this.filterStatus!=='' && this.filterStatus.label !=='ALL' && this.filterStatus !== null && this.filterStatus !== undefined) {
                  newUrl += "&status=" + this.filterStatus.label.toLowerCase();
                }
                console.log(newUrl)

                Axios.Get(newUrl)
                    .then(resp => {
                      if(this.device_list.length > 0) {
                        this.$vs.loading.close()
                        this.dataCount = 0
                        let maxLastHeartBeatTime = resp.data.device_max_last_heartbeat_time.split(" ")
                        this.displayNote = true 
                        this.lastMaxHeartBeatTime  = this.secToTime(maxLastHeartBeatTime[0])

                        if (resp.data.data.length != 0) {
                            this.dataCount = parseInt(resp.data.total)
                            this.totalData = parseInt(resp.data.total)
                            this.totalOnline = resp.data.total_online;
                            this.totalOnlinePercentage = (resp.data.total>0) ? ((resp.data.total_online/resp.data.total)*100).toFixed(2) : 0
                            this.totalOffline = resp.data.total - resp.data.total_online;
                            this.totalOfflinePercentage = (resp.data.total>0) ? (100 - this.totalOnlinePercentage).toFixed(2) : 0
                            
                        } else {
                            this.totalData = parseInt(resp.data.total)
                            this.totalOnline = 0;
                            this.totalOnlinePercentage = 0
                            this.totalOffline = 0;
                            this.totalOfflinePercentage = 0
                        }
                      }else{
                        this.$vs.loading.close()
                        this.dataCount = 0
                        this.totalOnline = 0
                        this.totalOffline = 0
                        this.totalOnlinePercentage = 0
                        this.totalOfflinePercentage = 0
                      }
                    })
                    .catch(e => {
                      this.totalOnline = 0
                      this.totalOffline = 0
                      this.totalOnlinePercentage = 0
                      this.totalOfflinePercentage = 0
                      this.$vs.loading.close()
                      console.log(e);
                    });
            },
            openLoading() {
                this.$vs.loading({
                    type: "default"
                });
            },
            detailRecord(data){
                this.$router.push({name:"DeviceMonitoringDetail", query:{id:data}})
            },
            updateDeviceList(event){
                let merchantidquery = ""

                this.filter_device = ''

                if (event !== null) merchantidquery = "?merchant_id="+event.id

                Axios.Get(url.svd.device.combo+merchantidquery).then(resp => {
                    this.device_list = []
                    if (typeof resp.data !== 'undefined')
                        for(let data of resp.data) {
                            data.label = data.name+' - '+data.code+' - '+data.merchant_full_name
                            data.name = data.name
                            this.device_list.push(data)
                        }
                })
            },
            boldenSuggestion(scope) {
              if (!scope) return scope;
              if (scope.query=='') {
                this.selected = null
              } 
              const {suggestion, query} = scope;
              let result = this.$refs.suggestComponent.displayProperty(suggestion);
              if (!query) return result;
              const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
              return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
            },
            getList() {
              let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;
              let merchantid =  ((merchant.id !== undefined )?merchant.id:((merchant.parent_id !== undefined) ? merchant.parent_id:""))
              let url = this.urlx.svd.merchant.list_by_parent_id+"/"+merchantid
              if (this.model !== null) url += "?search_merchant=" + this.model

              return new Promise((resolve, reject) => {
                  Axios.Get(url).then(response => {
                      if (response.code !== 200) {
                          reject()
                      }
                      let result = []
                      let i = 1
                       result.push({
                         id: i,
                         name: "Select All", 
                         text: " - Select All", 
                         code: "select_all"
                      })
                      for(let data of response.data) {
                        data.merchant_id = data.id
                        data.id = i + 1
                        let depth = "- "
                        data.name = depth.repeat(data.depth)+data.full_name
                        data.text = depth.repeat(data.depth)+data.full_name
                        data.code = data.code
                        i++
                        if (data.depth < 4) {
                          result.push(data)
                        }
                      }
                     
                      resolve(result)
                  }).catch(e => {
                      this.loading = false
                      reject(e)
                  })
              })
            },
            onSuggestSelect(suggest) {
                this.selected = suggest
            },
            secToTime(sec) {
              let minutes = (sec / 60);
              let hours = (sec / (60 * 60));
              let days = (sec / (60 * 60 * 24));
              if (sec < 60) return sec + " detik";
              else if (minutes < 60) return minutes + " menit";
              else if (hours < 24) return hours + " jam";
              else return days + " hari"
            },
            exportCSV() {
                
                this.openLoading()

                let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

                let merchantid =  ((merchant.id !== undefined)?merchant.id:((merchant.parent_id !== undefined) ? merchant.parent_id:""))
                
                this.isMerchantUser = (typeof merchant.code !== 'undefined' && merchant.code !== "") ? true : false
                let newUrl = ""

                newUrl = url.device_monitoring.list+ "?page=" + 1 + "&limit=" + 99999

                if (this.selected !== "" && this.selected !== null) {
                  if (typeof this.selected.code!=="undefined") {
                    newUrl +=  "&merchantcode="+ this.selected.code
                  }
                }

                if (this.filter_device !== "" && this.filter_device !== null) newUrl +=  "&devicename="+ this.filter_device.name

                if (merchantid !== "") newUrl += "&merchantid="+merchantid

                if (this.sortListColumn!=='' && this.sortListType!=='') {
                  newUrl += "&orderby=" + this.sortListColumn + "&sortby=" + this.sortListType
                }

                Axios.Get(newUrl)
                    .then(resp => {
                        this.$vs.loading.close()
                        this.dataExport = [];
                        if (resp.data.data.length != 0) {
                            this.totalData = parseInt(resp.data.total)
                            let no = 1;
                            for (let data of resp.data.data) {
                                data.no = ((this.page - 1) * this.limit) + no;
                                // data.online_status = data.device_is_online ? "<span class='text-success'><b>online</b></span>" : "<span class='text-danger'><b>offline</b></span>"
                                let channel_module_status_str = ""
                                if (data.hasOwnProperty("channel_module_init_result")) {
                                  let channel_module_init_result = data.channel_module_init_result
                                    if (channel_module_init_result != null && typeof channel_module_init_result==="object") {
                                      if (channel_module_init_result.length > 0) {
                                        for (let i in channel_module_init_result) {
                                          let channel_module_init_result_detail = channel_module_init_result[i]
                                            if (channel_module_init_result_detail != null && channel_module_init_result_detail.hasOwnProperty("channel_name") && channel_module_init_result_detail.hasOwnProperty("channel_status")) {
                                              if (channel_module_status_str == "") {
                                                channel_module_status_str += "" + channel_module_init_result_detail.channel_name;
                                              } else {
                                                channel_module_status_str += " - " + channel_module_init_result_detail.channel_name;
                                              }
                                            }
                                        }
                                      }
                                    }
                                  
                                }

                                if (typeof data.system_info.used_disk==="number" && typeof data.system_info.total_disk==="number") {
                                  let used_disk = parseFloat(data.system_info.used_disk)
                                  let total_disk = parseFloat(data.system_info.total_disk)
                                  let result = 0
                                  if (used_disk >= 0 && total_disk > 0) {
                                    result = (used_disk/total_disk) * 100
                                    data.capacity = result + "%"
                                  }
                                }else {
                                  data.capacity = "N/A"
                                } 
                               let lastHeartBeaat = moment(data.timestamp).format("YYYY-MM-DD HH:mm:ss")
                                this.dataExport.push({
                                  NO: data.no,
                                  "DEVICE NAME": data.device_name,
                                  "DEVICE CODE": data.device_code,
                                  "DEVICE TYPE": data.device_type,
                                  "SERIAL NUMBER": data.serial_number,
                                  "DEVICE CAPACITY": data.capacity,
                                  "LAST HEARTBEAT": lastHeartBeaat,
                                  "MERCHANT": data.merchant_name,
                                  "SAM STATUS": channel_module_status_str,
                                  "STATUS": (data.device_is_online == true) ? "Online": "Offline"
                              });
                              no++
                            }

                           

                            let maxLastHeartBeatTime = resp.data.device_max_last_heartbeat_time.split(" ")
                            this.lastMaxHeartBeatTime  = this.secToTime(maxLastHeartBeatTime[0])

                            let ws = XLSX.utils.json_to_sheet([],{skipHeader: true});
                            XLSX.utils.sheet_add_json(ws, [{Header: `Document di dowonload pada tanggal ${moment().format("DD-MM-YYYY HH:mm:ss")}`}], {skipHeader: true, origin: "A1"});
                            XLSX.utils.sheet_add_json(ws, [{ Header: `Notes: Device akan dinyatakan offline setelah pengiriman last hearbeat > ${this.lastMaxHeartBeatTime}`}], {skipHeader: true, origin: "A2"});
                            XLSX.utils.sheet_add_json(ws, this.dataExport, {skipHeader: false, origin: "A3"});


                            let exportDataCSV = XLSX.utils.sheet_to_csv(ws)
                            const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                            const link = document.createElement('a');
                            link.href = url;
                            let file_name = `device-monitoring_${moment().format("DD-MM-YYYY HHmmss")}.csv`
                            link.setAttribute('download', file_name);
                            document.body.appendChild(link);
                            link.click()
                            link.remove()

                                       
                        } 
                    })
                    .catch(e => {
                      console.log(e);
                    });
            },
        },
        mounted() {
            this.urlx = url
            this.gridApi = this.gridOptions.api;

            this.gridOptions.getRowStyle = function(params) {
                if (params.node.rowIndex % 2 === 0) {
                    return { background: '#f9f9f9' }
                }
            }
            this.gridOptions.rowHeight = 54;

            this.gridOptions.headerHeight = 15
            this.gridOptions.groupHeaderHeight = 75
            this.gridOptions.pivotGroupHeaderHeight = 50
            this.gridOptions.pivotHeaderHeight = 100

            // Axios.Get(url.svd.merchant.list).then(resp => {
            //     this.merchant_list = resp.data

            //     for (let data of this.merchant_list){
            //         data.label = data.full_name
            //     }
            // })

            let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

            let merchantidquery = ""

            let merchantid =  ((merchant.id !== undefined )?merchant.id:((merchant.parent_id !== undefined) ? merchant.parent_id:""))

            if (merchantid !== "") merchantidquery = "?merchant_id="+merchantid

            Axios.Get(url.svd.device.combo+merchantidquery).then(resp => {
                this.device_list = []
                if (typeof resp.data !== 'undefined')
                    this.device_list.push({
                      label: "Select All",
                      name: "Select All", 
                      text: "Select All", 
                      code: "select_all"
                    })
                    for(let data of resp.data) {
                        data.label = data.name+' - '+data.code+' - '+data.merchant_full_name
                        this.device_list.push(data)
                    }
            })

            // Axios.GetUserFromToken(url.svd.auth.me, {authToken:(typeof this.userInfo.access_token.token == 'undefined') ? "" : this.userInfo.access_token.token}).then(response =>{
            //     if(response.data.code == 200){
            //         if(response.data.data.role_details.length > 0){
            //             this.userInfo.group = response.data.data.role_details[0].group
            //         }
            //     }
            //     this.filter.merchant = this.showMerchantFilter ? "" : this.userInfo.merchant.code
            // })

            this.$root.$on("detail-from-ActionTableAgGridComponent", data => {
                this.detailRecord(data);
            });

            if(this.$route.params.data) {
              let {page, limit, status} = this.$route.params.data
              if(status == "offline") {
                this.filterStatus = {id: 2, label: "OFFLINE"};
              }else {
                this.filterStatus = {id: 1, label: "ONLINE"};
              }
              this.fetchData(page, limit)
            }
        }
    }
</script>

<style>
    /* .ag-pivot-off {
      height: 50px;
      min-height: 50px;
      background: #f2f2f2;
    } */
    .vdp-datepicker input {
        padding: .7rem;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #626262;
        width: 100%
    }

    .flatpickr-input {
        padding: .7rem;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #626262;
        width: 100%;
    }

  .vue-simple-suggest.designed .suggestions {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      top: calc(100% + 5px);
      border-radius: 3px;
      border: 1px solid #aaa;
      background-color: #fff;
      opacity: 1;
      z-index: 1000;
      overflow: scroll;
      height: 300px;
  }
  .cell-wrap-text {
    white-space: pre-wrap !important;
  }
  </style>